module.exports = __webpack_public_path__ + "img/edit-icon.31b2628f.svg";